'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { StoreDevtoolsName } from '../store-names.const'

import { toastInitialState } from './toast.slice'
import type { ToastItem, ToastStore } from './toast.type'
import { shouldScheduleToastDismiss } from './toast.utils'

const generateToastId = (): string => `toast-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`

export type {
  ToastAction,
  ToastButtonVariant,
  ToastItem,
  ToastPosition,
  ToastStore,
  ToastStoreActions,
  ToastStoreState,
} from './toast.type'
export const useToastStore = create<ToastStore>()(
  devtools(
    (set, get) => ({
      ...toastInitialState,
      showToast: (toast) => {
        const id = generateToastId()
        const newToast: ToastItem = {
          id,
          variant: 'success',
          position: 'bottom-right',
          closeButton: true,
          ...toast,
        }

        set((state) => ({ toasts: [...state.toasts, newToast] }))

        if (shouldScheduleToastDismiss(newToast.duration)) {
          setTimeout(() => get().removeToast(id), newToast.duration)
        }

        return id
      },
      removeToast: (id) => {
        set((state) => ({ toasts: state.toasts.filter((item) => item.id !== id) }))
      },
    }),
    { name: StoreDevtoolsName.Toast, enabled: process.env.NODE_ENV === 'development' }
  )
)
